<template>
  <tr
    :class="{
      'table__tr--background': validateIsInserted(),
      'table__tr--red': invoice.ESTAT === 'VENCIDO',
    }"
  >
    <!-- Customer Number -->
    <td v-if="isGroup">
      {{ !validateIsInserted() ? `${formatCustomer(invoice.KUNNR)}` : '' }}
    </td>
    <!-- RFC -->
    <td v-if="isGroup">
      {{ !validateIsInserted() ? invoice.STCD1 : '' }}
    </td>
    <!-- Document Number -->
    <td style="position: relative">
      {{ invoice.BELNR }}
      <special-order-type-icon
        :order="invoice.AUART"
        :cancelled="invoice.STIPO"
      />
    </td>
    <!-- Purchase order -->
    <td>
      {{ !validateIsInserted() ? invoice.ORDCOM : '-' }}
    </td>
    <!-- Downloads -->
    <td>
      <div class="d-flex justify-content-center">
        <div class="d-flex align-items-start" style="width: 70px">
          <download-invoice-tooltip :invoice-id="invoice.BELNR" :type="1" />

          <download-invoice-tooltip :invoice-id="invoice.BELNR" :type="2" />

          <template v-if="!invoice.inserted">
            <download-invoice-tooltip
              v-if="invoice.ACUSEDOC !== ''"
              :invoice-id="invoice.BELNR"
              :type="3"
            />

            <download-invoice-tooltip
              v-if="invoice.ACUSEDOC64 == '1' && invoice.ACUSEDOC == ''"
              :invoice-id="invoice.BELNR"
              :type="4"
            />

            <download-invoice-tooltip
              v-if="invoice.ACUSEFAC64 == '1' && invoice.ACUSEDOC == ''"
              :invoice-id="invoice.BELNR"
              :type="5"
            />
          </template>
        </div>
      </div>
    </td>
    <!-- Document Type-->
    <td>
      <div class="d-flex align-items-center">
        <div v-if="!validateIsInserted()" style="min-width: 30px">
          <v-icon
            v-if="invoice.DETFAC !== undefined && invoice.DETFAC.length > 0"
            small
            color="#5600e8"
            @click="$emit('actionButton')"
          >
            {{ invoice.isOpen ? 'mdi-minus-circle' : 'mdi-plus-circle' }}
          </v-icon>
        </div>
        <span class="w-100">{{ invoice.TIPO }}</span>
        <div style="min-width: 32px">
          <span
            v-if="invoice.AUGRU"
            class="badge rounded-pill"
            style="background: #306b75"
            >{{ invoice.AUGRU }}</span
          >
        </div>
      </div>
    </td>
    <!-- Document Date -->
    <td>{{ invoice.BUDAT }}</td>
    <!-- Delivery Date -->
    <td>{{ invoice.FACUS }}</td>
    <!-- Expiration Date -->
    <td>{{ !validateIsInserted() ? invoice.FVENC : '-' }}</td>
    <!-- Overdue days -->
    <td>{{ !validateIsInserted() ? invoice.DVENC : '-' }}</td>
    <!-- Amount -->
    <td>${{ invoice.DMBTR | formatCurrency }}</td>
    <!-- unexpired balance -->
    <td>
      {{
        !validateIsInserted() ? `$${formatCurrency(invoice.por_vencer)}` : '-'
      }}
    </td>
    <!-- Overdue balance -->
    <td>
      {{ !validateIsInserted() ? `$${formatCurrency(invoice.vencido)}` : '-' }}
    </td>
  </tr>
</template>

<script>
  import SpecialOrderTypeIcon from '@/components/SpecialOrderTypeIcon.vue';
  import DownloadInvoiceTooltip from '@/components/DownloadInvoiceTooltip.vue';

  export default {
    components: {
      SpecialOrderTypeIcon,
      DownloadInvoiceTooltip,
    },
    props: {
      isGroup: {
        type: Number,
        required: true,
      },
      invoice: {
        type: Object,
        required: true,
      },
    },
    methods: {
      validateIsInserted() {
        return this.invoice.inserted;
      },
      formatCurrency(value) {
        return this.$options.filters.formatCurrency(value);
      },
      formatCustomer(value) {
        return this.$options.filters.formatCustomer(value);
      },
    },
  };
</script>

<style scoped>
  .table__tr--red {
    color: red;
  }
  .table__tr--background td {
    background: #f2f2f2;
  }
  .td__tooltip--absolute {
    position: absolute;
    right: 5px;
    top: 5px;
  }
</style>
